
























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import Language from "@/models/language/language.model";
@Component
export default class LanguageGroupBase extends BaseVue {
  protected id: number|null = null;
  protected loading = false;
  protected repository!: BaseRepository<Language>;
  protected name = '';
  protected model: Language | any = null;

  created() {
      this.id = Number.parseInt(this.$route.params.languageId);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<Language>("Languages");
      this.getData();
    }
  }

  @Watch('model')
  onModelChange() {
    if (this.model) this.name = this.hasParent && this.model ? this.model.name : "---";
  }
  gotToList() {
    this.$router.push("/Language");
  }
  protected async getData() {
    try {    
      if(this.id) {
        this.model = await this.repository.getById(this.id);
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {

    }
  }
  get hasParent() {
    return !!this.$route.params.languageId;
  }
}
